import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { paymentProviderTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { Departments } from '@/types';
import { toasts } from '@/utils/toasts';

export const addPaymentProvider = (
  data: paymentProviderTypes.AddPaymentProviderData
): Promise<{ paymentProvider: paymentProviderTypes.PaymentProvider }> => {
  return axios.put('/payment-providers', data);
};

type AddPaymentProviderOptions = {
  department: Departments;
  onSuccess: () => void;
  config?: MutationConfig<typeof addPaymentProvider>;
};

export function useAddPaymentProvider({
  config = {},
  department,
  onSuccess,
}: AddPaymentProviderOptions) {
  return useMutation({
    ...config,
    onSuccess: () => {
      queryClient.invalidateQueries(['payment-providers', department]);
      toasts.loadingToast.success('add-payment-provider', 'Payment provider added successfully');
      onSuccess();
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('add-payment-provider', serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading('add-payment-provider', 'Adding payment provider...');
      config.onMutate?.(...args);
    },
    mutationFn: addPaymentProvider,
  });
}
